import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_RateAnAdviser.scss'
import { Form, Radio, Row, Col } from 'react-bootstrap'
import SubmitButton from '../../common/forms/SubmitButton'
import EmailAddressInput from '../../common/forms/EmailAddressInput'
import RatingQuestion from './RatingQuestion'
import SubmitSpinner from '../../common/Spinners/SubmitSpinner'
import SuccessCheckMessage from '../../common/SuccessCheckMessage'

class RateAdviserPage extends React.Component {
  static propTypes = {
    validate: PropTypes.func.isRequired,
    setRating: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
    onRadioButtonValueChanged: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    backToSearchPage: PropTypes.func.isRequired,
    submittedStatus: PropTypes.string.isRequired,
    navigationBack: PropTypes.func.isRequired,
    emailAddress: PropTypes.string.isRequired,
    adviserName: PropTypes.string.isRequired
  }

  handleRadioChange = (event, type) => {
    this.props.onRadioButtonValueChanged(event, type)
    this.props.validate(type)
  }

  handleRatingChange = (value, ratingType) => {
    this.props.setRating(value, ratingType)
    this.props.validate('ratings')
  }

  handleEmailChange = (value) => {
    this.props.setEmail(value)
    this.props.validate('email')
  }

  render () {
    const basevalidationstate = this.props.isInvalid
    const metvalidationstate = basevalidationstate.MetAdviserContainer.isInvalid
    const appointvalidationstate = basevalidationstate.AppointAdviserContainer.isInvalid
    const metHelp = basevalidationstate.MetAdviserContainer
    const appointHelp = basevalidationstate.AppointAdviserContainer
    const submittedStatus = this.props.submittedStatus
    const message = 'Thank you for rating ' + this.props.adviserName + '. A link has been sent to your email for you to confirm the rating.'
    const isSubmitting = submittedStatus === 'SUBMITTING'
    const isSubmitted = submittedStatus === 'SUBMITTED'
    const rateThisAdviser = 'Rate ' + this.props.adviserName

    const buttonDisabled = !this.props.isInvalid.formIsValid || isSubmitting

    return (
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <h2>{rateThisAdviser}</h2>
          <section className={styles['questions']}>
            <Form.Group>
              <h5 className={styles['margin-bottom-control-label']}>Did you meet this Financial Adviser?</h5>
              {!metHelp.valid && <Form.Text>{metHelp.help}</Form.Text>}
              <Row>
                <Col xs={3} sm={2} md={2} lg={2}>
                  <Form.Check
                    inline
                    type='radio'
                    name='MetAdviser'
                    value='yes'
                    onChange={(event) => this.props.onRadioButtonValueChanged(event, 'metAdviser')}
                    label={<span>{'Yes'}</span>}
                  />
                </Col>
                <Col xs={2} sm={2} md={2} lg={2}>
                  <Form.Check
                    inline
                    type='radio'
                    name='MetAdviser'
                    value='no'
                    onChange={(event) => this.props.onRadioButtonValueChanged(event, 'metAdviser')}
                    label={<span>{'No'}</span>}
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <h5 className={styles['margin-bottom-control-label']}>Did you appoint them as your Adviser?</h5>
              {!appointHelp.valid && <Form.Text>{appointHelp.help}</Form.Text>}
              <Row >
                <Col xs={3} sm={2} md={2} lg={2}>
                  <Form.Check
                    inline
                    type='radio'
                    name='AppointAdviser'
                    value='yes'
                    onChange={(event) => this.props.onRadioButtonValueChanged(event, 'appointAdviser')}
                    label={<span>{'Yes'}</span>}
                  />
                </Col>
                <Col xs={2} sm={2} md={2} lg={2}>
                  <Form.Check
                    inline
                    type='radio'
                    name='AppointAdviser'
                    value='no'
                    onChange={(event) => this.props.onRadioButtonValueChanged(event, 'appointAdviser')}
                    label={<span>{'No'}</span>}
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <h5 className={styles['ratings-questions'] + ' ' + styles['margin-bottom-control-label']}>How would you rate this Financial Adviser?</h5>
              <RatingQuestion question={'On the service you received.'} setRating={this.props.setRating} ratingType={'serviceReceived'} />
              <RatingQuestion question={'On their understanding of your investment needs.'} setRating={this.props.setRating} ratingType={'understandingOfNeeds'} />
              <RatingQuestion question={'On their understanding of investment matters.'} setRating={this.props.setRating} ratingType={'understandingOfMatters'} />
              <RatingQuestion question={'On the way they disclosed fees and costs to you.'} setRating={this.props.setRating} ratingType={'disclosedFees'} />
              <RatingQuestion question={'On how likely you are to recommend this financial adviser to friends or family.'} setRating={this.props.setRating} ratingType={'wouldRecommend'} />
            </Form.Group>
            <Form.Group >
              <Row>
                <Col xs={12} sm={12} md={6} lg={6}>
                  <EmailAddressInput id='emailAddress'
                    isInvalid={this.props.isInvalid.EmailContainer}
                    setEmail={this.props.setEmail}
                    label={'Please enter your email address to prevent duplicate ratings'}
                    value={this.props.emailAddress}
                    required
                    placeholder={'Email Address'}
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <SubmitButton
                    buttonText='Submit'
                    isSubmitting={isSubmitting}
                    onClick={this.props.handleSubmit}
                    isValid={this.props.isInvalid.formIsValid}
                    disabled={buttonDisabled}
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                  { isSubmitting && <SubmitSpinner /> }
                  { isSubmitted && <SuccessCheckMessage message={message} removeMargin /> }
                </Col>
              </Row>
            </Form.Group>
          </section>
        </Col>
      </Row>
    )
  }
}
export default  (RateAdviserPage)

